import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

const queryClient = new QueryClient()

const container = document.getElementById('root')

if (!container) {
  throw new Error('Root element not found.')
}

const root = ReactDOM.createRoot(container)

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)

reportWebVitals()